module.exports = __webpack_public_path__ + "img/public/SiteIcons/send-message-icon.svg?15580bc4";